import { AspectRatio, Card, Flex, Heading, Inset, Link, Text } from '@radix-ui/themes'
import { MailIcon, PhoneIcon, UserCircleIcon, BuildingIcon } from 'lucide-react'

import ClientBase from '../interfaces/ClientBase'

export const ClientCard = ({ client }: { client: ClientBase | null }) => {
  const cleanPhone = client?.phone ? client.phone.replace(/\D/g, '') : ''
  const isCompany = client?.type === 'Legal Entity'

  return (
    <Card>
      {client ? (
        <Flex gap="4">
          <Inset side="left" style={{ minWidth: '12rem' }}>
            <AspectRatio
              ratio={1}
              style={{
                backgroundColor: 'var(--gray-6)',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'hidden',
                display: 'flex',
              }}
            >
              {isCompany ? <BuildingIcon color="var(--gray-8)" size="4em" /> : <UserCircleIcon color="var(--gray-8)" size="4em" />}
              <Text color="gray">{isCompany ? 'Empresa' : 'Cliente'}</Text>
            </AspectRatio>
          </Inset>
          <Flex direction="column">
            <Heading size="3" mb="2" className="flex items-center gap-2">
              {`${client.firstname} ${client.lastname || ''}`.trim()}
              {isCompany && (
                <span className="bg-indigo-100 text-indigo-800 text-xs px-2 py-0.5 rounded-full font-medium border border-indigo-200">
                  Empresa
                </span>
              )}
            </Heading>
            {client.email && (
              <Flex gap="2" align="center">
                <MailIcon />
                <Link href={`mailto:${client.email}`}>{client.email}</Link>
              </Flex>
            )}
            {client.phone && (
              <Flex gap="2" align="center">
                <PhoneIcon />
                <Link href={`tel:${client.phone}`}>{client.phone}</Link>
              </Flex>
            )}
            {cleanPhone && (
              <Flex gap="2" align="center">
                <img src="/icons/whatsapp.svg" alt="WhatsApp" width={16} height={16} />
                <Link href={`https://wa.me/${cleanPhone}`} target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </Link>
              </Flex>
            )}
          </Flex>
        </Flex>
      ) : (
        <>
          <div className="text-6xl">👤</div>
          <span className="mt-2 text-sm font-medium">Seleccionar Cliente</span>
        </>
      )}
    </Card>
  )
}
